/**
 * @file feedback 常量
 * @author malcolmmzma
 */

import _ from 'lodash';

export const DISCONTENT_REASONS_MAP = {
  chart_error: '图表异常',
  ai_summary_issue: 'AI 总结有问题',
  no_data: '没有数据',
  filter_search_sort_error: '筛选/搜索/排序异常',
  data_inaccurate: '数据不准',
  structure_issue: '结构有问题',
  other: '其它',
} as const;

export const DISCONTENT_DATA = _.map(DISCONTENT_REASONS_MAP, (label, value) => ({
  label,
  value,
}));

export const EMOJI_DATA = [
  {
    label: '很不满',
    value: 1,
    lottieURL: 'https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/lottie-emoji-henbuman.json?max_age=31536000',
  },
  {
    label: '不满意',
    value: 2,
    lottieURL: 'https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/lottie-emoji-bumanyi.json?max_age=31536000',
  },
  {
    label: '一般',
    value: 3,
    lottieURL: 'https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/lottie-emoji-yiban.json?max_age=31536000',
  },
  {
    label: '满意',
    value: 4,
    lottieURL: 'https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/lottie-emoji-manyi.json?max_age=31536000',
  },
  {
    label: '很满意',
    value: 5,
    lottieURL: 'https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/lottie-emoji-henmanyi.json?max_age=31536000',
  },
];
